import { render } from "./CollectUsers.vue?vue&type=template&id=70e9b384"
import script from "./CollectUsers.vue?vue&type=script&lang=js"
export * from "./CollectUsers.vue?vue&type=script&lang=js"

import "./CollectUsers.vue?vue&type=style&index=0&id=70e9b384&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__